import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaInstagram } from "react-icons/fa";

import { useGetUserMeta } from "@/api/queries";
import useDomainConfigAuth from "@/api/sanity/queries/getSiteConfigWithDomain";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import H1 from "@/components/H1";
import Input from "@/components/Input";
import P from "@/components/P";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddInstagram() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  // const addAccount = AppState.useState(s => s.addAccount);
  const addAccount = useAppStore(state => state.addAccount || {});
  const userMeta = useGetUserMeta();
  const [pending, setPending] = useState(false);
  const { data: domainConfig } = useDomainConfigAuth();
  const isTunecore = domainConfig?.display_name === "TuneCore";

  let title = t("onboarding:add-instagram-header1");
  let desc = t("onboarding:add-instagram-desc1");

  switch (userMeta?.data?.role) {
    case "Manager":
      title = t("onboarding:add-instagram-header2");
      desc = t("onboarding:add-instagram-desc2");

      break;
    default:
      break;
  }

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">
        <p className="text-6xl text-white">
          <FaInstagram />
        </p>

        <Spacer />

        <>
          <H1>{title}</H1>
          <Spacer />
          <P>{desc}</P>
          <Spacer />
          <div className="relative flex flex-col items-center justify-center w-full text-ink-primary">
            <div
              className={`w-full lg:w-1/3  ${
                isTunecore ? "tunecore-input-hover" : ""
              }`}
            >
              <Input
                className={`${
                  isTunecore ? "auth-tunecore-page-input" : "auth-page-input"
                }`}
                placeholder="@username"
                whiteLabelText
                value={addAccount.instagram}
                onChange={e =>
                  useAppStore.setState(state => ({
                    addAccount: {
                      ...state.addAccount,
                      instagram: e.target.value,
                    },
                  }))}
              />
            </div>
          </div>
        </>

        <Spacer />

        <div className="flex flex-row justify-center w-full lg:w-1/3">
          <AuthPrimaryButton
            pending={pending}
            onClick={() => {
              void navigate({ to: "/add-account-6" });
              setPending(true);
            }}
            arrow
          >
            {t("common:_done")}
          </AuthPrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default AddInstagram;
